import { ReactNode } from 'react';
import { WixDesignSystemDefaultProps } from './types';

export interface WixDesignSystemDefaultPropsProviderProps {
  defaults: WixDesignSystemDefaultProps;
  children?: ReactNode;
}
